@if (item().url) {
  <a
    [routerLink]="nav.getRouterLink(item())"
    [queryParams]="nav.getQueryParams(item())"
    [target]="item().target"
    class="side-nav-link"
    [class.disabled]="item().isDisabled"
    [class.special-menu]="item().isSpecial"
    [class.active]="nav.isActive(item())"
    [attr.data-active-link]="nav.isActive(item())"
  >
    @if (item().icon) {
      <img [src]="nav.getIconSrc(item())" alt="" class="menu-icon" />
    }
    <span class="menu-text">{{ item().label }}</span>
    @if (item().badge; as badge) {
      <span [class]="`badge text-bg-${badge.variant}`">{{ badge.text }}</span>
    }
  </a>
}
